<template>
  <div class="inner pr-footer">
    <div class="footer-content">
      <el-row>
        <el-col :span="itemSpan"><span>主办单位：湖北省知识产权局</span></el-col>
        <el-col :span="itemSpan"><span>电话：027-86759088</span></el-col>
        <el-col :span="itemSpan"><span>网站标识码：4200000072</span></el-col>
      </el-row>
      <el-row>
        <el-col :span="itemSpan"><span>制作维护：湖北省知识产权局</span></el-col>
        <el-col :span="itemSpan"><span>地址：武汉市武昌区公正路19号</span></el-col>
        <el-col :span="itemSpan">
          <span>站内导航：</span>
            <span class="nav">
              <a href="http://zscqj.hubei.gov.cn/fzlm/wzdt/" target="_blank" title="">网站地图</a>
              <a href="https://c3.icoremail.net/" title="">内部邮箱</a>
              <a href="http://zscqj.hubei.gov.cn/fzlm/xxtj/index.shtml" title="">信息统计</a>  
            </span> 
          </el-col>
      </el-row>
    </div>
    <hr>
    <div class="version-div">
      <span><a href="http://beian.miit.gov.cn/" target="_blank" style="margin:0" title="">鄂ICP备20000291号</a></span>
      <span><a class="footer_gat" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42010602004146" target="_blank" title=""><img src="./guohui.png" alt="">&ensp;鄂公网安备42010602004146号</a></span>
      <!-- <span>版权所有 © 2021-2030 鄂ICP备28888000号-1</span> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'homeFooter',
  components: { },
  props: {
    'screenWidth': Number,
    'isMobile': Boolean
  },
  created() {

  },
  watch:{
    screenWidth:function(val,oldVal){
      if (val <= window.SITE_CONFIG['mobilePx']) {
        this.itemSpan = 12
        this.rowGutter = 10
        this.colPercent = 12
        this.colInfoPercent = 12
      }else{
        this.itemSpan = 8
        this.rowGutter = 20
        this.colPercent = 6
        this.colInfoPercent = 8
      }
    }
  },
  data() {
    return {
      itemSpan: 8,
      rowGutter:20,
      colPercent:6,
      colInfoPercent:8,
      hoverSelect: '',
      footerSelectOne:'',
      footerSelectOneOptions:[
      {label:'国家市场监督管理总局',value:'http://www.samr.gov.cn'},
      {label:'国家知识产权局',value:'https://www.cnipa.gov.cn'},
      {label:'国家外汇管理局',value:'http://www.safe.gov.cn//'},
      {label:'国家中医药管理局',value:'http://www.satcm.gov.cn//'},
      {label:'国家药品监督监管局',value:'https://www.nmpa.gov.cn//'},
      {label:'中华人民共和国国家邮政局',value:'http://www.spb.gov.cn/'},
      {label:'中国民用航空局',value:'http://www.caac.gov.cn//'},
      {label:'国家烟草专卖局',value:'http://www.tobacco.gov.cn/html/'},
      {label:'国家粮食和物资储备局',value:'http://www.lswz.gov.cn/'},
      {label:'国家信访局',value:'http://www.gjxfj.gov.cn/gjxfj/index.htm'},
      {label:'国务院港澳事务办公室',value:'http://www.hmo.gov.cn/'},
      {label:'国务院侨务办公室',value:'http://www.gqb.gov.cn//'},
      ],      
      footerSelectTwo:'province',
      footerSelectTwoOptions:[
      {label:'省直部门',value:'province'},
      {label:'国家知识产权局',value:'patent'},
      {label:'国家中医药管理局',value:'medical'}
      ],  
      footerSelectThree:'ones',    
      footerSelectThreeOptions:[
      {label:'各省市知识产权局',value:'ones'},
      {label:'国家知识产权局',value:'patent'},
      {label:'国家中医药管理局',value:'medical'}
      ],      
      footerSelectFour:'ins',    
      footerSelectFourOptions:[
      {label:'省内市州局',value:'ins'},
      {label:'国家知识产权局',value:'patent'},
      {label:'国家中医药管理局',value:'medical'}
      ],
    }
  },
  methods: {
    hover(val){
      document.getElementById(val).classList.add("ul_active");
    },
    leave(val){
      document.getElementById(val).classList.remove("ul_active");
    },

  }
}
</script>
<style lang="scss" scoped>
  .el-row {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }

  }
</style>